import { useState } from 'react'

const useManageComputation = props => {
  const {
    returnQuantity,
    qty,
    selectedPart,
    partNumber,
    returnRequest,
    eligibleStatuses,
    orderItemStatus,
    buttonLabel,
    submitSelect,
    orderQty,
    itemPrice,

  } = { ...props }
  const returnQty = !returnQuantity || returnQuantity > qty ? qty : returnQuantity
  const displayNull = selectedPart !== null
  && (selectedPart !== partNumber || returnRequest.return_request_id || returnRequest.rma_id)
  && submitSelect
  const { order_item_id: orderItemId } = returnRequest
  const hasRMA = orderItemId || false
  const hasEligibleStatus = eligibleStatuses.includes(orderItemStatus)
  const eligibleRMA = !hasRMA && hasEligibleStatus
  const showCheckBox = !['Submit', 'Next', 'Submit All Returns'].includes(buttonLabel) && eligibleRMA
  const qtyToShowOnRange = eligibleRMA ? qty : orderQty
  const qtyRange = Array.from(Array(qtyToShowOnRange + 1).keys())
  const itemPriceParsed = parseFloat(itemPrice) || 0
  const [selectedQty, setSelectedQty] = useState(parseInt(qtyToShowOnRange, 10))
  const qtyWithPart = selectedPart ? returnQty : selectedQty
  const qtyToCompute = eligibleRMA ? qtyWithPart : orderQty
  const itemTotal = (itemPriceParsed * qtyToCompute).toFixed(2)

  return {
    displayNull,
    showCheckBox,
    itemTotal,
    qtyRange,
    setSelectedQty,
    hasEligibleStatus,
    hasRMA,
    eligibleRMA,
    qtyToCompute,
    itemPriceParsed,
    selectedQty,
  }
}

export default useManageComputation
